const aiConversationMonitorTypes = {
  RESET_AI_CONVERSATION_MONITOR_STATE: 'RESET_AI_CONVERSATION_MONITOR_STATE',

  SYNC_LIVE_AI_CONVERSATIONS: {
    REQUEST: 'SYNC_LIVE_AI_CONVERSATIONS.REQUEST',
    SUCCESS: 'SYNC_LIVE_AI_CONVERSATIONS.SUCCESS',
    FAILURE: 'SYNC_LIVE_AI_CONVERSATIONS.FAILURE',
  },

  SYNC_TODAY_AI_CONVERSATIONS: {
    REQUEST: 'SYNC_TODAY_AI_CONVERSATIONS.REQUEST',
    SUCCESS: 'SYNC_TODAY_AI_CONVERSATIONS.SUCCESS',
    FAILURE: 'SYNC_TODAY_AI_CONVERSATIONS.FAILURE',
  },

  FETCH_MONITOR_LEADS: {
    REQUEST: 'FETCH_MONITOR_LEADS.REQUEST',
    SUCCESS: 'FETCH_MONITOR_LEADS.SUCCESS',
    FAILURE: 'FETCH_MONITOR_LEADS.FAILURE',
  },

  TAKE_BACK_AI_CONVERSATIONS: {
    REQUEST: 'TAKE_BACK_AI_CONVERSATIONS.REQUEST',
    SUCCESS: 'TAKE_BACK_AI_CONVERSATIONS.SUCCESS',
    FAILURE: 'TAKE_BACK_AI_CONVERSATIONS.FAILURE',
  },

  STOP_ALL_AI_CONVERSATIONS: {
    REQUEST: 'STOP_ALL_AI_CONVERSATIONS.REQUEST',
    SUCCESS: 'STOP_ALL_AI_CONVERSATIONS.SUCCESS',
    FAILURE: 'STOP_ALL_AI_CONVERSATIONS.FAILURE',
  },
};

export default aiConversationMonitorTypes;
